import React, { useContext, useEffect } from 'react';
import { Button, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles.module.css';
import { useHistory } from 'react-router-dom';
import { ROUTES, REGISTRATION_TYPE } from 'const';
import { OnlinePurchaseContext } from 'Context/OnlinePurchaseContext';
import { calculatePayableAmount } from 'helpers/SubscriptionHelper';

const PLAN_MAPPING = {
  'Sanoft Lite': 'sanoft-lite',
  'Sanoft Pro': 'sanoft-pro',
  'Sanoft Elite': 'sanoft-elite',
};

const PLAN_DATA = [
  {
    title: 'Sanoft Lite',
    subtitle: 'Perfect start for small businesses',
    price: '5000',
    features: [
      'Basic billing & POS operations',
      'Inventory management',
      'Multipayment support',
      'Offline mode with auto sync',
      'Basic reporting & Analytics',
      'Customer management',
      'KOT management',
    ],
  },
  {
    title: 'Sanoft Pro',
    subtitle: 'Advanced features for growing businesses',
    price: '7000',
    highlight: true,
    badge: '★ Best value',
    features: [
      'All Lite features',
      'Advanced reporting & Dashboards',
      'Product & category schedule',
      'Price category',
      'Charges & Discounts',
      'Variants & Add-ons',
      'Stock transfer between branches',
    ],
  },
  {
    title: 'Sanoft Elite',
    subtitle: 'Take your operations to the next level',
    price: '9000',
    features: [
      'All Lite + Pro features',
      'Waiter order taking',
      'Salesperson management',
      'Area & Tables management',
      'Advanced security options',
      'Integration with third party softwares',
    ],
  },
];

export default function PlanPrice({ open, onClose }) {
  const history = useHistory();
  const { setPurchaseData, subscriptionsAndAddons, loadSubscriptionsAndAddons } = useContext(OnlinePurchaseContext);
  useEffect(() => {
    if (open) {
      loadSubscriptionsAndAddons();
    }
  }, [open, loadSubscriptionsAndAddons]);

  const handleBuyButton = async (plan) => {
    const subKey = PLAN_MAPPING[plan.title];
    const sub = (subscriptionsAndAddons?.subscriptions || []).find((s) => s.key === subKey);

    if (!sub) return;

    const amount = sub.yearly_price;

    const { tax, payable } = calculatePayableAmount(amount, sub?.country);

    const data = {
      subscription: {
        key: sub.key,
        id: sub.id,
        validity: 365,
        name: sub.name,
        price: amount,
      },
      add_ons: [],
      amount,
      tax,
      payable,
      action_type: REGISTRATION_TYPE.RENEWAL,
    };

    setPurchaseData(data);
    history.push(ROUTES.PROCESS_PAYMENT);
  };
  if (!open) return null;

  return (
    <div className={styles.popUp}>
      <div className={`${styles.contentWrapper} ${styles.planPriceWrapper}`}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>Choose Your Plan</h2>
          <CloseIcon className={styles.cursorPointer} onClick={onClose} />
        </div>

        <div className={styles.inputSec}>
          <Box className={styles.pricingContainer}>
            {PLAN_DATA.map((plan, index) => (
              <Box key={index} className={`${styles.card} ${plan.highlight ? styles.highlight : ''}`}>
                {plan.badge && <div className={styles.badge}>{plan.badge}</div>}
                <Typography variant="h6" component="h3">
                  {plan.title}
                </Typography>
                <Typography className={styles.subtitle}>{plan.subtitle}</Typography>
                <Typography variant="h3" component="h1" className={styles.planPrice}>
                  ₹{plan.price}
                  <span>/Year</span>
                </Typography>

                <Button variant="contained" className={styles.button} onClick={() => handleBuyButton(plan)}>
                  Upgrade Now
                </Button>

                <ul>
                  {plan.features.map((feature, fIndex) => (
                    <li key={fIndex}>{feature}</li>
                  ))}
                </ul>
              </Box>
            ))}
          </Box>
        </div>

        <div className={`${styles.footSec} ${styles.planPriceFootSec}`}>
          <Box className={styles.footerLinks}>
            <a href="https://sanoft.com/terms" target="_blank" rel="noreferrer" className={styles.footerLink}>
              Terms of Service
            </a>
            <span className={styles.dividerDot}>•</span>
            <a href="https://sanoft.com/privacy" target="_blank" rel="noreferrer" className={styles.footerLink}>
              Privacy Policy
            </a>
          </Box>
        </div>
      </div>
    </div>
  );
}
